import { getUserData } from '@/core/auth/utils'

// Функция для добавления <noscript> пикселя в <body>
function addNoScriptPixel() {
    const metrikaId = import.meta.env.VITE_APP_YANDEX_METRIKA_ID
    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${metrikaId}" style="position:absolute; left:-9999px;" alt="" /></div>`
    document.body.appendChild(noscript)
}

export default {
    install() {
        // Получаем ID из переменных окружения Vite
        const metrikaId = import.meta.env.VITE_APP_YANDEX_METRIKA_ID
        // Если ID не задан в .env файле, ничего не делаем
        if (!metrikaId) {
            console.log('Yandex Metrika is disabled for this environment.')
            return
        }

        // Инициализация счетчика
        ;(function (m, e, t, r, i, k, a) {
            m[i] =
                m[i] ||
                function () {
                    ;(m[i].a = m[i].a || []).push(arguments)
                }
            m[i].l = 1 * new Date()
            for (let j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) {
                    return
                }
            }
            ;(k = e.createElement(t)),
                (a = e.getElementsByTagName(t)[0]),
                (k.async = 1),
                (k.src = r),
                a.parentNode.insertBefore(k, a)
        })(
            window,
            document,
            'script',
            'https://mc.yandex.ru/metrika/tag.js',
            'ym'
        )

        ym(metrikaId, 'init', {
            defer: true,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
        })

        const sendUserParams = () => {
            const currentUserData = getUserData()
            if (!currentUserData) {
                return
            }

            ym(metrikaId, 'userParams', {
                user_id: currentUserData?.user?.id,
                login: currentUserData?.user?.login,
            })
        }

        sendUserParams()

        window.addEventListener('user-data-updated', sendUserParams)
        window.addEventListener('storage', event => {
            if (event.key === 'userData') {
                sendUserParams()
            }
        })

        // Добавляем пиксель для тех, у кого отключен JS
        addNoScriptPixel()
    },
}
